<template>
  <v-form ref="faixa">
    <v-autocomplete
      v-model="filter.territorioIniciativaId"
      :items="values"
      clearable
      :label="'Iniciativas'"
      item-text="nomeIniciativa"
      item-value="territorioIniciativaId"
      :multiple="multiple"
      v-on:change="$emit('onChange', valores)"
      :disabled="disabled"
      hide-details="auto"
      :rules="rules"
      ref="faixa"
      class="faixa"
      :return-object="true"
    >
      <div
        style="display: flex; padding: 0 16px; cursor: pointer"
        slot="prepend-item"
        ripple
        @click="toggle"
        v-if="multiple"
      >
        <div style="margin-right: 32px">
          <v-icon
            :color="
              filter.territorioIniciativaId.length > 0 ? 'indigo darken-4' : ''
            "
            >{{ iconMultiple }}</v-icon
          >
        </div>
        <div>Todos</div>
      </div>
      <v-divider slot="prepend-item" class="mt-2" v-if="multiple" />

      <template v-slot:selection="{ item, index }">
        <span v-if="index < maxDisplay">{{ item.nomeIniciativa }} &nbsp;</span>
        <span v-if="index === maxDisplay" class="grey--text caption"
          >(+{{
            filter.territorioIniciativaId.length - maxDisplay
          }}
          iniciativas)</span
        >
      </template>

      <template slot="no-data"> Nenhuma iniciativa retornada </template>
    </v-autocomplete>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { territorioIniciativaAPI } from "@/modules/gestao-territorios/API/territorioIniciativaAPI";

export default {
  name: "ComboboxTerritorioIniciativaByEixo",
  props: {
    filter: { territorioIniciativaId: [] },
    itens: [],
    disabled: false,
    multiple: false,
    rules: [],
    territorioCategoriaId: null,
    iniciativasSelecionadas: [],
  },
  data() {
    return {
      maxDisplay: 1,
      valores: [],
      values: [],
    };
  },
  computed: {
    ...mapGetters(["user", "isAT"]),
    likesAll() {
      return this.filter.territorioIniciativaId.length === this.values.length;
    },
    likesSome() {
      return this.filter.territorioIniciativaId.length > 0 && !this.values;
    },
    iconMultiple() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  mounted() {
    this.load();
  },
  watch: {
    territorioCategoriaId(value) {
      this.load();
    },
  },
  methods: {
    load() {
      territorioIniciativaAPI
        .obterPorEixo(this.territorioCategoriaId)
        .then(({ data }) => {
          this.values = data;
          const iniciativasSelecionadasId = this.iniciativasSelecionadas.map(
            (item) => item.territorioIniciativaId
          );

          if (
            this.iniciativasSelecionadas &&
            this.iniciativasSelecionadas.length > 0
          ) {
            this.values = this.values.filter(
              (item) =>
                !iniciativasSelecionadasId.includes(item.territorioIniciativaId)
            );
          }
        })
        .catch((err) => {
          console.log("ERROR ComboboxTerritoiosIniciativas --> ", err);
          this.$notification.error("Erro ao obter iniciativas");
        });
    },
    async isValid() {
      return await this.$refs.faixa.validate();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.territorioIniciativaId = [];
          this.$emit("onChange", this.valores);
        } else {
          this.filter.territorioIniciativaId = this.values.slice();
          this.$emit("onChange", this.valores);
        }
      });
    },
  },
};
</script>
<style>
.v-list-item__title {
  white-space: normal;
}

.v-autocomplete__content {
  max-width: 500px;
}

.v-list-item {
  padding: 5px 10px;
}

.v-list-item:not(:last-of-type) {
  border-bottom: 1px solid #c8c3c3;
}
</style>
